{
  "cookies.en": {
    "`mailto:${site.privacyEmail}`": "mailto:support@newera.inc"
  },
  "cookies.vi": {
    "`mailto:${site.privacyEmail}`": "mailto:support@newera.inc"
  },
  "delete-account.en": {
    "`mailto:${site.deletionEmail}?subject=${subject}&body=${body}`": "mailto:support@newera.inc?subject=%5BNexa%5D%20Account%20deletion%20request&body=My%20account%20email%2Fusername%3A%20%0A%0AI%20request%20deletion%20of%20my%20account%20and%20related%20data."
  },
  "delete-account.vi": {
    "`mailto:${site.deletionEmail}?subject=${subject}&body=${body}`": "mailto:support@newera.inc?subject=%5BNexa%5D%20Y%C3%AAu%20c%E1%BA%A7u%20x%C3%B3a%20t%C3%A0i%20kho%E1%BA%A3n&body=Email%2Ft%C3%AAn%20%C4%91%C4%83ng%20nh%E1%BA%ADp%20t%C3%A0i%20kho%E1%BA%A3n%20c%E1%BB%A7a%20t%C3%B4i%3A%20%0A%0AT%C3%B4i%20y%C3%AAu%20c%E1%BA%A7u%20x%C3%B3a%20t%C3%A0i%20kho%E1%BA%A3n%20v%C3%A0%20d%E1%BB%AF%20li%E1%BB%87u%20li%C3%AAn%20quan."
  },
  "privacy.v1.en": {
    "`mailto:${site.privacyEmail}`": "mailto:support@newera.inc"
  },
  "privacy.v1.vi": {
    "`mailto:${site.privacyEmail}`": "mailto:support@newera.inc"
  },
  "support.en": {
    "`mailto:${site.supportEmail}`": "mailto:support@newera.inc"
  },
  "support.vi": {
    "`mailto:${site.supportEmail}`": "mailto:support@newera.inc"
  },
  "terms.v1.en": {
    "`mailto:${site.supportEmail}`": "mailto:support@newera.inc"
  },
  "terms.v1.vi": {
    "`mailto:${site.supportEmail}`": "mailto:support@newera.inc"
  }
}
